import { useEffect } from 'react'
import { useWebsocketConnection } from 'providers/WebsocketProvider'
import { useAuth } from 'hooks/UseAuth'
import { useQueryClient } from 'react-query'
import { useCurrentWorkspaceId } from './useCurrentWorkspaceId'

const LEFT_SIDEBAR_CHANNEL_NAME = 'LeftSidebarChannel'

export const useLeftSidebarChannel = (location?: string) => {
  const websocketConnection = useWebsocketConnection()
  const queryClient = useQueryClient()
  const auth = useAuth()
  const currentWorkspaceId = useCurrentWorkspaceId()

  useEffect(() => {
    if (!websocketConnection || !auth) return

    const subscriptionParams = {
      channel: LEFT_SIDEBAR_CHANNEL_NAME,
      user_id: auth.id,
      workspace_id: currentWorkspaceId,
    }
    const subscription = websocketConnection.subscriptions.create(subscriptionParams, {
      received: () => {
        if (!!location) {
          queryClient.invalidateQueries(['workspace', currentWorkspaceId, 'files', location])
        } else {
          queryClient.invalidateQueries(['workspace', currentWorkspaceId, 'files'])
        }
      },
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [websocketConnection, auth, currentWorkspaceId, queryClient, location])
}
